import * as React from 'react';
import { nanoid } from 'nanoid';
export const useUniqueId = (id, callback) => {
    const [idVar, setId] = React.useState('');
    React.useEffect(() => {
        setId(id || nanoid());
        if (callback)
            callback();
    }, [id, callback]);
    return [idVar, setId];
};
//# sourceMappingURL=useUniqueId.js.map